module.exports = __webpack_public_path__ + "d90cb8dc93c665308237f58ee8d12c09.png";